import * as React from "react";
import { SVGProps, memo } from "react";

const ButtonArrow = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={16} viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g clipPath="url(#clip0_2127_265)"><path d="M18.1721 10.4139L19.5861 8.99991L0 8.99991V6.99991L19.5861 6.99991L18.0001 5.414L19.4141 4L23.4141 7.99991L19.5861 11.8279L18.1721 10.4139Z" fill="currentColor" /></g><defs><clipPath id="clip0_2127_265"><rect width={24} height={16} fill="white" /></clipPath></defs></svg>;

const Memo = memo(ButtonArrow);
export default Memo;